module.exports = __webpack_public_path__ + "static/media/carExplore.6aa2d057.png";